import * as React from "react";
import { styled, Tooltip } from "@mui/material";
import Markdown from "react-markdown";
import { ValidatedIndicator } from "./ValidatedIndicator";

//region [[ Styles ]]
const AnnotatedTextContainer = styled("div")({
  "& p": {
    margin: 0,
  },
  "& h3": {
    margin: 0,
    fontSize: "1em",
  },
  "& ol, ul": {
    paddingInlineStart: 20,
    marginBlockStart: 0,
    marginBlockEend: 0,
    whiteSpace: "normal !important",
  },
  "& li": {
    margin: "10px 0",
  },
});
const FootNoteLink = styled("sup")(({ theme }) => ({
  marginLeft: 2,
  color: theme.palette.primary.main,
  cursor: "pointer",
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underline",
  },
  "&:dir(rtl)": {
    marginLeft: 0,
    marginRight: 2,
  },
}));
//endregion [[ Styles ]]

//region [[ Props ]]
export interface AnnotatedTextProps {
  markdown: string;
  withValidationIcon?: boolean;
  onFootnoteClick: (id: number) => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const AnnotatedText = ({
  markdown,
  withValidationIcon,
  ...props
}: AnnotatedTextProps) => {
  const onFootnoteClick = (id: string) => {
    if (props.onFootnoteClick) props.onFootnoteClick(parseInt(id) - 1);
  };
  return (
    <AnnotatedTextContainer>
      <Markdown
        children={markdown}
        components={{
          a(props) {
            const { children, href: id, title } = props;
            return (
              <Tooltip
                key={`footnoteTip${id}`}
                title={
                  <div>
                    {withValidationIcon && <ValidatedIndicator />}
                    <span className={"medium-tooltip multiline-tooltip"}>
                      {title}
                    </span>
                  </div>
                }
                placement="top"
                arrow
              >
                <FootNoteLink
                  key={`footnote${id}`}
                  onClick={() => onFootnoteClick(id)}
                >
                  {children}
                </FootNoteLink>
              </Tooltip>
            );
          },
        }}
      />
    </AnnotatedTextContainer>
  );
};
